import { useState } from "react";

const LoginPopup = () => {
  const [isOpen, setIsOpen] = useState(true);

  const closePopup = () => {
    setIsOpen(false);
  };

  const handleBannerClick = () => {
    window.open("https://sajutalktalk.com/product/eventsaju/", "_blank");
    closePopup();
  };

  if (!isOpen) return null;

  return (
    <div className="login_popup_backdrop" onClick={closePopup}>
      <div className="login_popup_container" onClick={(e) => e.stopPropagation()}>
        <div className="login_popup_content" onClick={handleBannerClick}>
          <img
            src="https://sajutalktalk.com/wp-content/uploads/2025/07/%EC%A0%9C%EB%AA%A9%EC%9D%84-%EC%9E%85%EB%A0%A5%ED%95%B4%EC%A3%BC%EC%84%B8%EC%9A%94.-22.png"
            alt="72% 할인 이벤트"
            className="login_popup_image"
          />
          <div className="login_popup_text">
            <div className="login_popup_header">
              72% 할인! 병오년 패키지 🤫
            </div>
            <div className="login_popup_detail">
              70,000원 → 19,900원 비공개 특가!
            </div>
            <div className="login_popup_price">
              19,900원 특가 구매하러 가기
            </div>
          </div>
        </div>
        <div className="login_popup_cta" onClick={closePopup}>
          닫기
        </div>
      </div>
    </div>
  );
};

export default LoginPopup;
